import { contextPath } from 'util/history';
import { post } from 'epics/ajax';
import type { CmdbObjectResponse } from './types';

export const fetchCmdbObjects = (
    portalId: number,
    requestTypeId: number,
    fieldId: string,
    inputValue: string,
    fieldValueMap: string[][]
): Promise<CmdbObjectResponse> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldValueMapObject = fieldValueMap.reduce((accumulator: any, field: [string, string]) => {
        if (field[0] !== 'attachment') {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            accumulator[field[0]] = field[1];
        }

        return accumulator;
    }, {});

    const body = {
        fieldValueMap: fieldValueMapObject,
        query: inputValue,
    };
    return (
        post(
            `${contextPath}/rest/servicedesk/cmdb/1/customer/portal/${portalId}/request/${requestTypeId}/field/${fieldId}/autocomplete`,
            body,
            { 'Content-Type': 'application/json' }
        )
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            .map(({ response }) => ({ cmdbObjects: response.results, total: response.total }))
            .toPromise()
    );
};
